import { AdaptAiBannerVariant } from './adapt-ai-banner';

// AB TEST - AI-1771
export const ADAPT_DESTINATION_ARMS = {
    LANDING: 'landing',
    TOOL: 'tool',
    // Outside the experiment, not evaluated, or any other value: the entry point keeps today's link
    DEFAULT: 'default'
} as const;

export type AdaptDestinationArm = (typeof ADAPT_DESTINATION_ARMS)[keyof typeof ADAPT_DESTINATION_ARMS];

// The October cohort: teachers the experiment assigns to either arm. They see the eduki Adapt launch banner and modal,
// whether or not they are in MCP-1473; everyone else keeps the MCP-1473 ones
export const isAdaptLaunchArm = (arm: AdaptDestinationArm): boolean => arm !== ADAPT_DESTINATION_ARMS.DEFAULT;

// The two editions of the My Materials banner and the order confirmation modal: MCP-1473's copy test, as on
// origin/master, and the eduki Adapt launch the October cohort sees. Each has its own copy and its own dismissal flag
export const ADAPT_ENTRY_POINT_EDITIONS = {
    LEGACY: 'legacy',
    LAUNCH: 'launch'
} as const;

export type AdaptEntryPointEditionName = (typeof ADAPT_ENTRY_POINT_EDITIONS)[keyof typeof ADAPT_ENTRY_POINT_EDITIONS];

export type AdaptEntryPointEdition =
    | { name: typeof ADAPT_ENTRY_POINT_EDITIONS.LAUNCH }
    | { name: typeof ADAPT_ENTRY_POINT_EDITIONS.LEGACY; copyVariant: AdaptAiBannerVariant };

// Whether the teacher closed each edition of one entry point on an earlier visit
export type AdaptEntryPointDismissals = {
    isLegacyDismissed: boolean;
    isLaunchDismissed: boolean;
};

export type AdaptCtaTarget = {
    arm: AdaptDestinationArm;
    url: string;
};

// Where the teacher clicked, recorded with the arm on the QE `click_adapt_cta` event.
// The order confirmation page is the thank-you page: the modal shows on desktop, the banner on mobile, and the modal on
// every device for the October cohort. The KI Tools banner (AI-1775) shows only to the October cohort
export const ADAPT_CTA_ENTRY_POINTS = {
    MY_MATERIALS_BANNER: 'my_materials_banner',
    ORDER_CONFIRMATION_BANNER: 'order_confirmation_banner',
    ORDER_CONFIRMATION_MODAL: 'order_confirmation_modal',
    KI_TOOLS_BANNER: 'ki_tools_banner'
} as const;

export type AdaptCtaEntryPoint = (typeof ADAPT_CTA_ENTRY_POINTS)[keyof typeof ADAPT_CTA_ENTRY_POINTS];
